import { useMutation } from '@tanstack/react-query';
import Comment, { CommentableType } from '@spraypaint/Comment';

export const useAddComment = (callBack?: () => void) =>
  useMutation({
    mutationFn: async ({
      commentableId,
      content,
      commentableType,
    }: {
      commentableId?: string;
      content: string;
      commentableType: CommentableType;
    }) => {
      const newComment = new Comment({
        commentable_id: commentableId,
        commentable_type: commentableType,
        content,
      });
      await newComment.save();
    },
    onSuccess: () => {
      if (callBack) callBack();
    },
  });
